import { ChangeEvent } from 'react';
import { SearchInput } from '@ds';
import { AdminPageHeader, DataTable } from '@ui';
import {
  PERFUSION_SET_LIST_FILTERS_BASE,
  PERFUSION_SET_TABLE_COLUMNS,
  PerfusionSetsFilters,
  getRenderPerfusionSetsTableCell,
} from '@lp/features/admin/tables/PerfusionSetsListTable';
import { usePerfusionSetsListQuery } from '@/queries/perfusion-sets';
import { useFilterQueryWithParams } from '@/hooks/useFilterQueryWithParams';

export const PerfusionSetsList = () => {
  const {
    data,
    isLoading,
    isFetching,
    filters,
    hasFilters,
    updateFilters,
    clearFilters,
    page,
    itemsPerPage,
    searchText,
    sortBy,
    setPage,
    setItemsPerPage,
    setSearchText,
    setSortBy,
  } = useFilterQueryWithParams({
    filterList: PERFUSION_SET_LIST_FILTERS_BASE,
    query: usePerfusionSetsListQuery,
  });

  const onSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  return (
    <div className="flex flex-col place-items-stretch gap-9">
      <AdminPageHeader title="OCS Perfusion Sets">
        <div className="max-w-[480px] grow">
          <SearchInput placeholder="Search" value={searchText} onChange={onSearchChange} inputVariant="secondary" />
        </div>
      </AdminPageHeader>
      <div className="flex flex-col gap-4">
        <PerfusionSetsFilters
          filters={filters}
          hasFilters={hasFilters}
          updateFilters={updateFilters}
          clearFilters={clearFilters}
        />
        <DataTable
          label="OCS Consoles"
          columns={PERFUSION_SET_TABLE_COLUMNS}
          renderCell={getRenderPerfusionSetsTableCell}
          data={data?.items || []}
          isLoading={isLoading}
          isFetching={isFetching}
          totalItems={data?.totalItems || 0}
          totalPages={data?.totalPages || 1}
          page={page}
          itemsPerPage={itemsPerPage}
          sortBy={sortBy}
          onPageChange={setPage}
          onItemsPerPageChange={setItemsPerPage}
          onSortByChange={setSortBy}
        />
      </div>
    </div>
  );
};
